import * as React from 'react';
import ModalContainer from '@af-common/Common/_containers/ModalContainer';
import { DocumentStatusTypes } from '../../Document/_stores/DocumentStore';
import PromptContainer from '@af-common/Common/_containers/PromptContainer';
import { Trans } from "react-i18next";
import Loader from '@af-common/Common/_components/Loader';
import { ButtonBase } from '@mui/material'

export type Props = {
	onNewPattern?: Function,
	setIntroOpen?: Function,
	status?: string
}

type State = {
	newOpened: boolean
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class SaveButton extends React.Component<Props> {
	state = {
		newOpened: false
	} as State

	private onNewClose = () => this.setState({newOpened: false});
	private onNewOpen = () => this.setState({newOpened: true});

	render = () => <>
		<ButtonBase style={ {borderRadius: '3px', marginBottom: '15px'} } >
			<div onClick={() => this.onNewOpen()} className="action-buttons-icon grey-border">
				<img src="static/img/icons/add-icon.svg" alt="" width="25" height="25" />
				<div className="text">NEW</div>
			</div>
		</ButtonBase>
		{this.props.status == DocumentStatusTypes.Saving && <ModalContainer preventClose opened={true} animate content={<Loader />} />}
		{/* New pattern Dialog */}
		<PromptContainer
			opened={this.state.newOpened}
			title={<T>Are you sure you want to start a new pattern?</T>}
			message={<T>This will clear the template. If you want to keep your current pattern, make sure to save it first</T>}
			actions={{
				"Confirm": () => {
					this.props.onNewPattern();
					this.onNewClose();
					this.props.setIntroOpen(true);
				}
			}}
			onClose={this.onNewClose}
			dismissible
		/>
	</>
}